"use client";

import { FC, useState } from "react";

import { Text } from "@Shared/ui";

import { Container, ContainerProps } from "./Container";
import { Form } from "./Form";
import { Success } from "./Success";

export type ModalGetInTouchProps = ContainerProps;

export const ModalGetInTouch: FC<ModalGetInTouchProps> = props => {
    const [isSuccess, setIsSuccess] = useState(false);

    return (
        <Container onOpen={() => setIsSuccess(false)} {...props}>
            {isSuccess ? (
                <Success />
            ) : (
                <>
                    <Text as="h2" variant="h2" weight={600}>
                        Get in touch
                    </Text>

                    <Form onSuccess={() => setIsSuccess(true)} />
                </>
            )}
        </Container>
    );
};
